import { combineReducers } from "redux";
import fixStepReducer, { IFixStep } from "./fixProgressSteps/fixStepReducer";
import jobReducer, { IJobListen } from "./job/jobReducer";
import { IJob2s } from "./job2/job2Interface";
import job2Reducer from "./job2/job2Reducer";
import jobnameReducer, { IJobName } from "./jobname/jobnameReducer";
import lineReducer, { ILine } from "./line/lineReducer";
import moduleReducer, { IModule } from "./module/moduleReducer";
import { IModuleDescription, IModuleSubDescription } from "./moduleListDescription/moduleListDescriptionInterface";
import moduleListDescriptionReducer from "./moduleListDescription/moduleListDescriptionReducer";
import paramReducer, { IModuleParams } from './param/paramReducer'
import progressStepReducer, { IProgressStep } from "./progressSteps/progressStepReducer";
import qualityControlReducer from "./qualityContorl/qualityControlReducer";

export interface IProgress {
    line: ILine;
    modules: IModule;
    params: IModuleParams;
    jobs: IJobListen;
    qualityControl: boolean;
    job2s: IJob2s;
    jobnames: IJobName;
    moduleListDescription: (IModuleDescription | IModuleSubDescription)[];
    progressStep: IProgressStep[];
    fixStep: IFixStep[];
}

const progressReducer = combineReducers({
    line: lineReducer,
    modules: moduleReducer,
    moduleListDescription: moduleListDescriptionReducer,
    params: paramReducer,
    jobs: jobReducer,
    qualityControl: qualityControlReducer,
    job2s: job2Reducer,
    jobnames: jobnameReducer,
    progressStep: progressStepReducer,
    fixStep: fixStepReducer,
})
export default progressReducer;

